import React from "react";
import { Grid, Section, Typography, Divider } from "../../core";
import { theme } from "../../styles";
import {
  useSelector,

  // useDispatch
} from "react-redux";
import { Row, Col } from "antd";
import styled from "styled-components";
import { MixStyle, media } from "../../styles";
import SendYarnForm from "../../components/SendYarnForm";
import SendYarnHistory from "../../components/SendYarnHistory";
// import { getSendYarn } from "../../redux/Action/Sizer/sendYarn";
const Notify_Utils = require("../../helper/utils/Notification");

const { colors } = theme;
const TittleWraper = styled.div`
  ${MixStyle.flexCenter};
  h1 {
    ${media.minitablet`font-size:36px;`};
  }
  .d-inline--block {
    display: inline-block;
  }
  .mt-0 {
    margin-top: 0px;
  }
`;
const SendYarn = () => {
  const sizerId = React.useState();
  let Error = useSelector((state) => state.errorReducer);
  return (
    <React.Fragment>
      {Error.id === "SEND_YARN_FAIL"
        ? Notify_Utils.openNotificationWithIcon(
            "error",
            "Error While Sending Yarn"
          )
        : Error.id === "SEND_YARN_SUCCESS"
        ? Notify_Utils.openNotificationWithIcon("success", Error.msg)
        : null}
      <Grid>
        <Row className="mt-50 mb-50" type="flex" justify="space-between">
          <Col lg={14} xs={24}>
            <Section padding="20px 0px 50px 0px">
              <TittleWraper>
                <Typography
                  className="d-inline--block"
                  align="center"
                  as="h1"
                  color={colors.darkPink}
                  weight="bold"
                >
                  Send Yarn to Sizer
                  <Divider className="mt-0" />
                </Typography>
              </TittleWraper>
              <SendYarnForm sizerId={sizerId} />
            </Section>
          </Col>
          <Col lg={9} xs={24}>
            <Section padding="20px">
              <Typography
                className="d-inline--block"
                align="center"
                as="h2"
                color={colors.Fiord}
                weight="bold"
              >
                Send Yarn History
              </Typography>
              <SendYarnHistory sizerId={sizerId[0]} />
            </Section>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
};

export default SendYarn;
